export enum AngularPaths {
  LOGIN = 'login',
  LOGIN_BY_TOKEN = 'login-by-token',
  ERROR = 'error',
  PASSWORD_UPDATE = 'password-update',
  SIGNTRUST = 'signtrust',
  SIGN_BY_AGENT = 'sign-by-agent',
  CERTIFICATES = 'certificates',
  NOT_FOUND = 'notfound',
  USER_PIN = 'user-pin',
  SSO_USER_PIN = 'sso-user-pin',
  CONFIG_USER_PIN = 'config-user-pin',
  MSAL_LOGOUT = 'msal-logout',
  MSAL_LOGIN_FAILED = 'msal-login-failed',
  DEFAULT = '/',
}
